import PropTypes from 'prop-types';
import React, {
  useEffect,
  useState,
} from 'react';

import { Map, Iterable } from 'immutable';

import Grid       from '@mui/material/Grid';
import TextField  from '@mui/material/TextField';

function Text({ name, value, onChange, disabled }) {
  const [state, setState] = useState(new Map());

  const localValue  = state.get('localValue', (value && value.get('value')) || '');

  function onTextChange(e) {
    const input = e.target.value;
    setState(state.set('localValue', input));

    // Note: Moved out of useEffect to avoid retriggering of "save()" when toggling back via "prev" button
    onChange(name, new Map({ text: input }));
  }

  return (
    <Grid container>
      <Grid item xs={12} sx={{ mt: 2 }}>
        <TextField
          id={name}
          type="text"
          InputLabelProps={{ shrink: true }}
          multiline
          rows={3}
          sx={{ width: '100%' }}
          value={localValue}
          onChange={(e) => onTextChange(e)}
          data-testid="textfield-text"
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
}

Text.defaultProps = {
  name:     null,
  value:    null,
  onChange: null,
  disabled: false,
};

Text.propTypes = {
  name:     PropTypes.string,
  value:    PropTypes.objectOf(Iterable),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Text;
